export const INTRO_HOME = `
<div class="reward-content">
  <div class="reward-part">
    <p style="text-align: left">
      Gương mặt người mẫu Việt Nam 2023 hay The Face Vietnam 2023 là cuộc thi và chương trình truyền hình thực tế về tìm kiếm và đào tạo người mẫu quảng cáo do Multimedia JSC sản xuất. Các huấn luyện viên của chương trình bao gồm siêu mẫu, diễn viên Anh Thư, siêu mẫu, diễn viên, nhà thiết kế, doanh nhân Vũ Thu Phương, siêu mẫu Phạm Đình Minh Triệu và Hoa hậu Việt Nam 2014 Nguyễn Cao Kỳ Duyên.
    </p>
     <p style="text-align: left">
     Chương trình lên sóng lúc 20h30 Chủ nhật hàng tuần trên kênh VTV9 - Đài truyền hình Việt Nam và các nền tảng digital của Multimedia bắt đầu từ ngày 4 tháng 6 năm 2023 đến ngày 13 tháng 8 năm 2023.
    </p>
    <p style="text-align:left">Là đơn vị độc quyền cung cấp nền tảng bình chọn chính thức của cuộc thi The Face Việt Nam 2023, Bvote tự hào đồng hành cùng các thí sinh, góp phần mang đến kết quả công bằng, minh bạch.</p>
    </div>
  </div>
</div>
`;

export const INTRO_TITLE = `Là cổng bình chọn chính thức của cuộc thi The Face Việt Nam 2023, Bvote tự hào mang đến giải pháp bình chọn trực tuyến công bằng, minh bạch cho các thí sinh.`;

export const INTRO = `
  <div class="reward-content">
  <div class="reward-part">
<div class="item">
<p>
<span style="font-size:16px; font-family: roboto; ">
<span style="color:#000000">
<span style="font-family:roboto">
Cổng bình chọn Bvote sẽ đồng hành cùng cuộc thi để tìm kiếm ra những thí sinh được yêu thích nhất qua sự bình chọn của khán giả. 
  </span>
  </span>
  </span>
  </p>
   <p>
  <span style="font-size:16px"><span style="color:#000000">
  <span style="font-family:roboto">
  Việc hoạt động dựa trên công nghệ chuỗi khối của Blockchain giúp giải pháp bình chọn của Bvote sở hữu những ưu điểm vượt trội về tính an toàn, bảo mật, đem lại kết quả công khai và minh bạch nhất. Thay vì sử dụng phương thức truyền thống bằng tin nhắn, khán giả sẽ ủng hộ cho thí sinh mình yêu thích nhất thông qua hệ thống bình chọn trên Website. Giải pháp này cho phép mọi người theo dõi kết quả liên tục, trực tiếp trên hệ thống, một điều mà các hình thức cũ không làm được. Không chỉ loại bỏ nguy cơ gian lận, Bvote còn mang đến trải nghiệm bình chọn mới lạ, tiện lợi và dễ sử dụng. Nhất là khi giải pháp bình chọn của Bvote còn kết hợp cùng các ví điện tử uy tín để đảm bảo mức độ bảo mật cao và giảm thiểu tối đa tình trạng hack vote.
  <br/>
  <br/>
  </span>
    </span>
      </p> 
      <p>
      &nbsp;
      </p> 
      <p>
      <span style="font-size:16px">
      <span style="color:#000000">
      <span style="font-family:roboto">
      <strong>
      Cách thức bình chọn:
      </strong>
      <br/>
      <br/>
      <strong>
      Ban tổ chức đưa lên thông tin thí sinh để khán giả bình chọn
      </strong>
      </span>
      </span>
      <span style="color:#000000">
      <span style="font-family:roboto"> 
      </span>
      </span>
      </span>
      </p>
       <p>
       <span style="font-size:16px">
       <span style="color:#000000">
       <span style="font-family:roboto">
       - <i>Bước 1: &nbsp;</i> Truy cập website: https://thefacevietnam2023.bvote.vn/. Tại phần Danh sách thí sinh, click chi tiết vào thí sinh muốn bình chọn
       </span>
       </span>
       </span>
       </p> 
       <p>
       <span style="font-size:16px">
       <span style="color:#000000">
       <span style="font-family:roboto">
       - <i>Bước 2: &nbsp;</i> Click Bình chọn Momo hoặc Bình chọn qua Ngân hàng, thẻ. Hệ thống sẽ trả về 1 link thanh toán để bình chọn thí sinh.
       </span>
       </span>
       </span>
       </p>
        <p><span style="font-size:16px">
        <span style="color:#000000">
        <span style="font-family:roboto">
        - <i>Bước 3: &nbsp;</i> Truy cập link thanh toán, tiến hành thanh toán (tương đương bình chọn). 

        </span>
        </span>
        </span>
        </p>
         <p>
         <span style="font-size:16px">
         <span style="color:#000000">
         <span style="font-family:roboto">
         - <i>Bước 4: &nbsp;</i> Hệ thống check thanh toán thành công, hệ thống Bvote sẽ tiến hành lưu trữ kết quả bình chọn. Phí bình chọn theo gói lựa chọn và 1 lượt bình chọn qua Momo tương đương với số điểm theo gói bình chọn mà khán giả đã chọn. Lưu ý sẽ không giới hạn số lượt bình chọn và số thí sinh bình chọn.
 
         </span>
         </span>
         </span>
         </p> 
   
         <br/>
          <p>
          &nbsp;
          </p> 
          <p>
          <span style="font-size:16px">
          <strong>
          <span style="color:#000000">
          <span style="font-family:roboto">
          Cơ cấu giải thưởng: 
          </span>
          </span>
          </strong>
          </span>
          </p> 
          <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           Cổng bình chọn của Bvote sẽ chính thức được mở vào 20h00 ngày 11/8/2023 và sẽ kết thúc vào 21h00 ngày 13/08/2023 để chọn ra thí sinh có điểm số cao nhất.
          </p> 
          
            <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
            Thí sinh có điểm số cao nhất sẽ nhận “Giải thưởng thí sinh yêu thích nhất The Face Việt Nam 2023” đồng thời sẽ cùng top 4 chung kết trải nghiệm tại Seoul Fashion Week do Beu model tài trợ. 
          </p> 
</div>
</div>
</div>
  `;
